module.exports = __webpack_public_path__ + "rotate.svg?ef85d392a8d9164b98cfe61f9b49b6f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotate.svg
// module id = 947
// module chunks = 0